import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    labelTypography: {
        color: theme.palette.secondary.dark,
        textTransform: 'uppercase'
    },
    valueTypography: {
    }
}));

export default function LabelValue(props) {
    const {
        label,
        value,
        children,
        className = ''
    } = props;
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, className)}>
            <Typography display="block" className={classes.labelTypography} gutterBottom>
                {label}
            </Typography>
            {value ? (
                <Typography variant="body1" className={classes.valueTypography}>
                    {value}
                </Typography>
            ) : children}
        </div>
    );
};

LabelValue.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    className: PropTypes.string
};